import { render, staticRenderFns } from "./SGReadyDialog.vue?vue&type=template&id=048caa23&scoped=true"
import script from "./SGReadyDialog.vue?vue&type=script&lang=js"
export * from "./SGReadyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048caa23",
  null
  
)

export default component.exports